import type { CrmEventDTO } from '../../../server/dto/crm-event-dto.ts';

export function getSortableEventId(event: CrmEventDTO) {
    return `${event.event_id}-${event.date}`;
}
